export default "__VITE_ASSET__d15215eb__"